<script>
    import Modal from './Modal.vue';
    import AppDownload from './AppDownload.vue';

    export default {
        name: 'AppDownloadModal',
        props: {
            isModalVisible: Boolean,
            required: true,
        },
        components: {
            Modal,
            AppDownload,
        },
    };
</script>

<template>
    <Modal v-show="isModalVisible" :isFooter="false" :isCross="true" @close="$emit('close')">
        <template slot="body">
            <AppDownload header="Los geht’s!">
            </AppDownload>
        </template>
    </Modal>
</template>

<style lang="scss" scoped>
    /deep/ .modal-header {
        padding-bottom: 10px;
    }
</style>